import styled from "styled-components";
import { Breadcrumb } from "antd";
import AntSelect from "uiKits/Select";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const accent = "#E8521A";
export const accentGreen = "#16a34a";
export const shopifyGreen = "#96bf48";

export const Page = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px ${PAGE_GUTTER.desktop}px 48px;
  box-sizing: border-box;

  ${media.downTablet`
    padding: 16px ${PAGE_GUTTER.tablet}px 32px;
  `}

  ${media.downMobile`
    padding: 12px ${PAGE_GUTTER.mobile}px 24px;
  `}
`;

export const StyledBreadCrumbs = styled(Breadcrumb)`
  margin-bottom: 8px;
  .ant-breadcrumb-link a,
  .ant-breadcrumb-link span {
    color: #9ca3af;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 400;
    text-decoration: none;
  }
  .ant-breadcrumb-link span {
    color: ${accent};
  }
  .ant-breadcrumb-link a:hover {
    color: ${accent};
  }
  .ant-breadcrumb-separator {
    margin-inline: 5px;
    color: #9ca3af;
  }
`;

export const PageTitleBar = styled.h1`
  font-family: "Syne", sans-serif;
  font-size: 22px;
  font-weight: 800;
  color: #111;
  margin: 0 0 24px;
  line-height: 1.2;

  ${media.downMobile`
    font-size: 18px;
    margin-bottom: 16px;
  `}
`;

export const PdpGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 580px) 1fr;
  gap: 48px;
  align-items: flex-start;

  ${media.downTablet`
    grid-template-columns: 1fr;
    gap: 32px;
  `}
`;

export const ImgPanel = styled.div`
  position: sticky;
  top: 24px;
  max-width: 100%;

  ${media.downTablet`
    position: relative;
    top: 0;
  `}
`;

export const ImgMain = styled.div`
  width: 100%;
  height: min(440px, 55vw);
  min-height: 280px;
  border-radius: 12px;
  overflow: hidden;
  background: ${(p) =>
    p.$hasImage
      ? "#f5f5f5"
      : "linear-gradient(135deg, #1a1a2e, #16213e)"};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  position: relative;
`;

export const MainImg = styled.img`
  width: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

export const ImgPlaceholder = styled.div`
  text-align: center;
  font-size: 120px;
  opacity: 0.9;
`;

export const ImgMainLabel = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-family: "Syne", sans-serif;
  font-size: 15px;
  font-weight: 700;
`;

export const ImgMainSublabel = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 300;
  margin-top: 3px;
`;

export const ImgThumbs = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ImgThumb = styled.button`
  width: 72px;
  height: 72px;
  min-width: 44px;
  min-height: 44px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid ${(p) => (p.$active ? accent : "#ebebeb")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 0;
  transition: border-color 0.15s;
  &:hover {
    border-color: ${accent};
  }
  img {
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${media.downMobile`
    width: 56px;
    height: 56px;
  `}
`;

export const ProductPanel = styled.div``;

export const ProductTitle = styled.h2`
  font-family: "Syne", sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #111;
  line-height: 1.45;
  margin: 0 0 10px;
`;

export const RatingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const ReviewsText = styled.span`
  font-size: 12px;
  color: #9ca3af;
`;

export const DividerV = styled.div`
  width: 1px;
  height: 14px;
  background: #e5e5e5;
`;

export const StockBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  background: #dcfce7;
  color: ${accentGreen};
`;

export const SupplierCard = styled.div`
  background: #f9f9f9;
  border: 1.5px solid #ebebeb;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 18px;
`;

export const SupplierCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 8px;
`;

export const SupplierTabLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${accent};
  border-bottom: 2px solid ${accent};
  padding-bottom: 4px;
  display: inline-block;
`;

export const SupplierVerified = styled.span`
  font-size: 10px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 999px;
  background: ${(p) => (p.$muted ? "#f3f4f6" : "#dcfce7")};
  color: ${(p) => (p.$muted ? "#6b7280" : accentGreen)};
  display: inline-flex;
  align-items: center;
  gap: 3px;
`;

export const SupplierMain = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

export const SupplierAvatar = styled.div`
  width: 38px;
  height: 38px;
  background: ${accent};
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Syne", sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
`;

export const SupplierName = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 2px;
`;

export const SupplierMeta = styled.div`
  font-size: 11px;
  color: #9ca3af;
  font-weight: 300;
`;

export const SupplierMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  ${media.downMobile`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const SupMetric = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 9px 10px;
  text-align: center;
`;

export const SupMetricVal = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 15px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 3px;
  color: ${(p) => p.$tone || "#111"};
`;

export const SupMetricLbl = styled.div`
  font-size: 9px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const PriceSection = styled.div`
  border: 1.5px solid #ebebeb;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 18px;
`;

export const PriceRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1px;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 14px;

  ${media.downMobile`
    grid-template-columns: 1fr;
  `}
`;

export const PriceBox = styled.div`
  background: #fff;
  padding: 12px 14px;
`;

export const PriceBoxLabel = styled.div`
  font-size: 10px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  font-weight: 500;
`;

export const PriceBoxVal = styled.div`
  font-family: "Syne", sans-serif;
  font-size: clamp(18px, 4vw, 22px);
  font-weight: 800;
  line-height: 1;
  color: ${(p) => p.$color || "#111"};
`;

export const MarginBarWrap = styled.div`
  margin-bottom: 10px;
`;

export const MarginBarLabel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const MarginBarTitle = styled.span`
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
`;

export const MarginBarPct = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${accentGreen};
`;

export const MarginBar = styled.div`
  height: 7px;
  background: #f0f0f0;
  border-radius: 999px;
  overflow: hidden;
`;

export const MarginBarFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, ${accent}, ${accentGreen});
  border-radius: 999px;
  width: ${(p) => p.$pct || 0}%;
  max-width: 100%;
`;

export const MarginTip = styled.div`
  font-size: 11px;
  color: #6b7280;
  font-style: italic;
  background: #f9f9f9;
  padding: 8px 12px;
  border-radius: 7px;
  border-left: 3px solid ${accent};
`;

export const QtyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

export const QtyLabel = styled.span`
  font-size: 13px;
  color: #374151;
  font-weight: 500;
`;

export const QtyControl = styled.div`
  display: flex;
  align-items: center;
  border: 1.5px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
`;

export const QtyBtn = styled.button`
  width: 34px;
  height: 34px;
  min-width: 44px;
  min-height: 44px;
  border: none;
  background: #f5f5f5;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter", sans-serif;
  color: #374151;
  &:hover {
    background: #ebebeb;
  }
`;

export const QtyInput = styled.input`
  width: 48px;
  height: 34px;
  min-height: 44px;
  border: none;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  outline: none;
  background: #fff;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ActionBtns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
`;

export const BtnCart = styled.button`
  background: #fff;
  color: ${accent};
  border: 2px solid ${accent};
  padding: 13px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  transition: all 0.2s;
  width: 100%;
  &:hover {
    background: #fff5f2;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const BtnImport = styled.button`
  background: ${accent};
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  width: 100%;
  box-shadow: 0 4px 14px rgba(232, 82, 26, 0.28);
  transition: all 0.2s;
  &:hover {
    background: #d44415;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const BtnShopify = styled.button`
  background: ${shopifyGreen};
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  width: 100%;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background: #7da832;
  }
  &:disabled {
    background: #d9d9d9 !important;
    cursor: not-allowed;
  }
`;

export const BtnEbay = styled.button`
  background:rgb(248, 1, 10);
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  width: 100%;
  transition: all 0.2s;
  &:hover {
    background: #c42b30;
  }
  &:disabled {
    background: #d9d9d9 !important;
    cursor: not-allowed;
  }
`;

export const FeaturesSection = styled.div`
  margin-bottom: 20px;
`;

export const FeaturesLabel = styled.div`
  font-size: 10px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;

  ${media.downTablet`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${media.downMobile`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const FeatItem = styled.div`
  background: #f9f9f9;
  border: 1.5px solid #f0f0f0;
  border-radius: 10px;
  padding: 12px 8px;
  text-align: center;
  transition: all 0.15s;
  &:hover {
    border-color: rgba(232, 82, 26, 0.3);
    background: #fff5f2;
    transform: translateY(-1px);
  }
`;

export const FeatIcon = styled.div`
  font-size: 22px;
  margin-bottom: 6px;
`;

export const FeatName = styled.div`
  font-size: 10px;
  color: #374151;
  font-weight: 500;
  line-height: 1.35;
`;

export const DescSection = styled.div`
  border-top: 1px solid #f0f0f0;
  padding-top: 18px;
  margin-bottom: 8px;
`;

export const DescHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
`;

export const DescTitle = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #111;
`;

export const DescToggle = styled.button`
  font-size: 12px;
  color: ${accent};
  cursor: pointer;
  font-weight: 500;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  &:hover {
    text-decoration: underline;
  }
`;

export const DescGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DescBlock = styled.div`
  background: #f9f9f9;
  border: 1.5px solid #f0f0f0;
  border-radius: 10px;
  padding: 13px 15px;
`;

export const DescBlockTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: #111;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 9px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DescList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const DescItem = styled.div`
  font-size: 12px;
  color: #374151;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.55;
  &::before {
    content: "";
    width: 5px;
    height: 5px;
    background: ${accent};
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 5px;
  }
`;

export const StatsBar = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-top: 20px;

  ${media.downTablet`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${media.downMobile`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const StatItem = styled.div`
  background: #fff;
  border: 1.5px solid #ebebeb;
  border-radius: 10px;
  padding: 12px 8px;
  text-align: center;
  transition: all 0.2s;
  &:hover {
    border-color: rgba(232, 82, 26, 0.25);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  }
`;

export const StatIconWrap = styled.div`
  font-size: 20px;
  margin-bottom: 5px;
`;

export const StatVal = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 15px;
  font-weight: 800;
  color: ${accent};
  line-height: 1;
  margin-bottom: 3px;
`;

export const StatLbl = styled.div`
  font-size: 9px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const OptionsBlock = styled.div`
  margin-bottom: 16px;
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
`;

export const StyledLabel = styled.span`
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  min-width: 80px;
`;

export const StyledSelect = styled(AntSelect)`
  flex: 1;
  min-width: 160px;
  max-width: 100%;
`;

export const LockHint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
`;

export const SignUpCta = styled(BtnImport)`
  margin-top: 0;
`;
